module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetMedium.d4a913e.jpg";